import React, { useState } from 'react';
import Modal from './Modal.js';

const ShareURL = () => {
  const [showShareModal, setShowShareModal] = useState(false);
  const [copied, setCopied] = useState(false);

  const currentUrl = window.location.href;
  const displayUrl = currentUrl.replace(/^https?:\/\//, '');

  // Vérification si l'URL contient "/session/[idsession]"
  const match = currentUrl.match(/\/session\/(\w+)/);
  const sessionId = match ? match[1] : null;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  const generateQRCodeUrl = (text) => {
    return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(text)}`;
  };

  return (
    <>
      <button 
        className="btn btn-secondary flex"
        style={{margin:'auto'}} 
        onClick={() => setShowShareModal(true)}
      >
        📤 Partager la session
      </button>

      {showShareModal && (
        <Modal 
          title="📤 Partager la session" 
          onClose={() => setShowShareModal(false)}
          size="medium"
        >
          <div className="text-center">
            <div className="form-group">
              <label className="form-label">🔗 URL de la page</label>
              <div className="flex gap-2">
                <input
                  type="text"
                  className="form-input"
                  value={currentUrl}
                  readOnly
                  style={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
                />
                <button
                  className={`btn ${copied ? 'btn-success' : 'btn-secondary'}`}
                  onClick={copyToClipboard}
                >
                  {copied ? '✅' : '📋'}
                </button>
              </div>
              {sessionId && (
                <p className="text-sm text-secondary mt-2">
                  Code de session : <strong className="text-primary">{sessionId}</strong>
                </p>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">📱 QR Code</label>
              <div className="flex justify-center">
                <div className="border rounded-lg p-4 bg-white">
                  <img
                    src={generateQRCodeUrl(currentUrl)}
                    alt="QR Code pour partager la session"
                    className="rounded"
                    style={{ width: '200px', height: '200px' }}
                  />
                </div>
              </div>
              <p className="text-sm text-secondary mt-2">
                Scannez ce code pour accéder directement à la session
              </p>
            </div>

            {copied && (
              <div className="text-success text-sm mt-3 success-check">
                ✅ URL copiée dans le presse-papiers !
              </div>
            )}
          </div>
        </Modal>
      )}
    </>
  );
};

export default ShareURL;